import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ISearchBoxProps, DialogFooter, CheckboxVisibility } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks"
import { getPage } from "../../../../app/Pages"
import { setPage } from "../../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../../common/Table/Table"
import { GetUsersRequest, GetUsersResponse, ResetUserPasswordRequest, UpdateUserActivityRequest, UpdateUserConfirmationStateRequest } from "../../../../repository/UserManagement/user_pb"
import { dismissMessage, getManagerUsers, getRoles, getUserTypes, reset, resetManagers, resetRoles, resetUserTypes, setActivityFilterOption, setConfirmationFilterOption, setNumberOfResults, setSort, setSearchText, setSelectedManager, setSelectedRole, setSelectedUserType, setTwoFactorFilterOption, updateConfirmationStatus, updateStatus, setIsFilteredManagersSet, setIsFilteredRolesSet, setIsFilteredUserTypesSet, updateUser, addUser, resetPassword, resetNewPassword, updateUsername } from "./UsersPageSlice"
import { ApiMessage, getHeaders } from "../../../../app/Api"
import { useId, useBoolean } from '@fluentui/react-hooks';

import * as google_protobuf_wrappers_pb from 'google-protobuf/google/protobuf/wrappers_pb'
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { getMainTheme } from "../../../../app/Themes"
import { SearchField } from "../../../common/SearchField/SearchField"
import { formatDate, printComponent, normalizeKey } from "../../../../app/Helpers"
import { TableState } from "../../../common/Table/TableSate"
import { Message } from "../../../common/Message/Message"
import { ShareBox } from "../../../common/ShareBox/ShareBox"
import { GetRolesRequest } from "../../../../repository/UserManagement/role_pb"
import { GetUserTypesRequest } from "../../../../repository/UserManagement/usertype_pb"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { bool, string } from "yup"
import { Popup } from "../../../common/Popup/Popup"
import { UsersForm } from "../../../forms/Management/Users/UsersForm"
import { FormType } from "../../../forms/FormProps"
import { UsernameUpdateForm } from "../../../forms/Management/Users/UsernameUpdateForm"
import { AccountSecurityForm } from "../../../forms/Management/Users/AccountSecurityForm"
import { useReactToPrint } from "react-to-print"
import { PageProps } from "../../PageProps"
import { List } from "../../../common/List/List"
import { UserTypesPage } from "../UserTypes/UserTypesPage"
import { RolesPage } from "../Roles/RolesPage"

const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
};


let req: GetUsersRequest;

let roleReq: GetRolesRequest;

let userTypeReq: GetUserTypesRequest;

let org: number = -1;

let getManagersPromise: any;
let getRolesPromise: any;
let getUserTypesPromise: any;


const key = "management/users"
export const UsersPage: React.FunctionComponent<PageProps> = (props) => {


    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const state: {
        isChangeStateLoading: boolean,
        managers: TableState, message: ApiMessage | undefined, roles: TableState,
        appTheme: string, isDarkModeEnabled: boolean, userTypes: TableState, searchText: string | undefined,
        activityFilterOption: { key: number, text: string },
        confirmationFilterOption: { key: number, text: string },
        twoFactorFilterOption: { key: number, text: string },
        filters: any[],
        newPassword: string | undefined
    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.managersPage.isChangeStateLoading,
            managers: state.managersPage.managers, message: state.managersPage.message, roles: state.managersPage.roles,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled, userTypes: state.managersPage.userTypes,
            searchText: state.managersPage.searchText, activityFilterOption: state.managersPage.activityFilterOption,
            confirmationFilterOption: state.managersPage.confirmationFilterOption, twoFactorFilterOption: state.managersPage.twoFactorFilterOption,
            filters: state.managersPage.filters,
            newPassword: state.managersPage.newPassword
        }
    })
    const calloutTargetId = useId('callout-target');
    const labelId = useId('callout-label');
    const statusActionConfirmationcalloutTargetId = useId('status-action-callout-target');
    const confirmActionConfirmationcalloutTargetId = useId('confirm-action-callout-target');
    const twoFactorActionConfirmationcalloutTargetId = useId('twof-action-callout-target');
    const resetPasswordActionConfirmationcalloutTargetId = useId('reset-pass-action-callout-target');

    const ActionConfirmationLabelId = useId('action-callout-label');
    const shareCalloutLabelId = useId('share-callout-label');
    const shareTargetId = useId('share-callout-target');

    const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
    const [isActionConfirmationCalloutVisible, { toggle: toggleisActionConfirmationCalloutVisible }] = useBoolean(false);
    const [isShareCalloutVisible, { toggle: toggleisShareCalloutVisible }] = useBoolean(false);

    const [currentAction, setCurrenctAction] = useState(0)
    const ref = useRef<HTMLDivElement>(null);

        const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});


    const getActionId = (action: number): string => {
        if (action == 1)
            return statusActionConfirmationcalloutTargetId;
        else if (action == 2) {
            return confirmActionConfirmationcalloutTargetId;
        } else if (action == 3) {
            return twoFactorActionConfirmationcalloutTargetId;
        } else if (action == 4) {
            return resetPasswordActionConfirmationcalloutTargetId;
        } else {
            return ""
        }
    }

    const _selection = useConst(() => new Selection({
        onSelectionChanged: () => {
            if (_selection.count > 0) {
                dispatch(setSelectedManager(_selection.getSelection()));
            } else {
                dispatch(setSelectedManager([]));
            }
        },

    }));

    const clearFilter = () => {

        dispatch(setSelectedUserType([]))
        req.setUsertype(-1)
    }

    const search = (searchText: string | undefined) => {
        let isFiltered: boolean = false;
        if (searchText) {
            const wrapper = new StringValue();
            wrapper.setValue(searchText.trim());
            req.setSearch(wrapper)
            isFiltered = true;
        } else {
            req.setSearch(undefined)
        }
   

        if (state.userTypes.selected.length > 0) {
            req.setUsertype(Number(state.userTypes.selected.at(0)?.id))
            isFiltered = true;


        } else {
            req.setUsertype(-1)
        }

     

        req.setNextto(0)
        dispatch(resetManagers())
        dispatch(setIsFilteredManagersSet(isFiltered))
        getManagersPromise?.abort()
        getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))
    }


    useEffect(() => {
        req = new GetUsersRequest();

        roleReq = new GetRolesRequest();

        userTypeReq = new GetUserTypesRequest();

        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
            }
        }
        if (!props.isSelection) {
            const page = getPage(key)
            dispatch(setTitle(t(normalizeKey(page?.title))));
            dispatch(setPage(page));
        }
        req.setNextto(0)
        req.setNumofresults(state.managers.numberOfResults)
        req.setOrder(state.managers.isDescending)
        req.setUsertype(-1)

        roleReq.setNumofresults(state.roles.numberOfResults)
        roleReq.setOrder(state.roles.isDescending)

        userTypeReq.setNumofresults(state.userTypes.numberOfResults)
        userTypeReq.setOrder(state.userTypes.isDescending)

        getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))
        return () => { //clean up
            getManagersPromise?.abort();
            getRolesPromise?.abort();
            getUserTypesPromise?.abort();
            dispatch(reset());
        }
    }, [])


    const c: IColumn[] = [

        {
            key: 'name',
            name: t("user"),
            minWidth: 20,
            maxWidth: 250,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                return <Link onClick={(e) => {
                    if (e) {
                        e.preventDefault();
                        navigate("/management/users/" + item?.internalId + ((org == -1) ? "" : "?org=" + org));
                    }
                }
                } href={"/management/users/" + item?.internalId + ((org == -1) ? "" : "?org=" + org)} ><Persona
                        text={item?.name == "" ? item?.internalId : item?.name}
                        secondaryText={item?.username}
                        size={PersonaSize.size40}

                    /></Link>

            },
        },

       


        {
            key: 'createdDate',
            name: t("createdDate"),
            minWidth: 20,
            maxWidth: 60,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {


                return <Text>{(item?.createdDate)}</Text>; //{item.createdDate}
            },
        },




    ];

    const _selectionItems: ICommandBarItemProps[] = [
        {
            key: 'edit',
            text: t("edit"),
            title: t("edit"),
            iconProps: { iconName: 'EditSolid12' },
            subMenuProps: {
                items: [{
                    key: 'editInfo',
                    text: t('editInfo'),
                    title: t("editInfo"),
                    iconProps: { iconName: 'EditContact', styles: { root: { fontWeight: "bold" } } },

                    onClick: () => {
                        if (!state.isChangeStateLoading) {
                            setCurrenctAction(101)
                        }

                    }
                },
                {
                    key: 'editUsername',
                    text: t("editUsername"),
                    title: t("editUsername"),

                    iconProps: { iconName: 'Accounts', styles: { root: { fontWeight: "bold" } } },
                    onClick: () => {
                        if (!state.isChangeStateLoading) {
                            setCurrenctAction(102)
                        }
                    }
                },
                {
                    key: 'twoFactor',
                    text: t("twoFactor"),
                    title: t("twoFactor"),

                    iconProps: { iconName: 'Lock', styles: { root: { fontWeight: "bold" } } },
                    onClick: () => {
                        if (!state.isChangeStateLoading) {
                            setCurrenctAction(103)
                        }
                    }
                }
                ]
            },

        },

        {
            key: 'status',
            text: (state.managers.selected.length > 0 && state.managers.selected.at(0)?.isActive) ? t("deactivateAccount") : t("activateAccount"),
            title: (state.managers.selected.length > 0 && state.managers.selected.at(0)?.isActive) ? t("deactivateAccount") : t("activateAccount"),
            iconProps: { id: statusActionConfirmationcalloutTargetId, iconName: (state.managers.selected.length > 0 && state.managers.selected.at(0)?.isActive) ? "UserRemove" : "UserFollowed", styles: { root: { fontWeight: (state.managers.selected.length > 0 && state.managers.selected.at(0)?.isActive) ? undefined : "bold" } } },

            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 1 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 1 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 1 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(1)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },

        {
            key: 'resetPassword',
            text: t("resetPassword"),
            title: t("resetPassword"),

            iconProps: { id: resetPasswordActionConfirmationcalloutTargetId, iconName: "PasswordField", styles: { root: { fontWeight: "bold" } } },
            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 4 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 4 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 4 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(4)
                    toggleisActionConfirmationCalloutVisible()
                }
            },
        },
        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.managers.selected.at(0)?.internalId + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },
        {
            key: 'share',
            text: t("share"),
            title: t("share"),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },


    ];

    const mainOptions: ICommandBarItemProps[] = [
        {
            key: 'newItem',
            text: t('add'),
            title: t("add"),
            iconProps: { iconName: 'Add' },
            onClick: () => {
                //  navigate("add")
                setCurrenctAction(100)
            }
        },
        {
            key: 'refresh',
            text: t('refresh'),
            title: t("refresh"),
            iconProps: { iconName: 'refresh' },
            disabled: state.managers.isFetching,
            onClick: () => {
                dispatch(resetManagers())
                req.setNextto(0)
                //   if (!state.searchText || state.searchText?.trim().length == 0) {
                //     req.setSearch(undefined)
                //}
                getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))
            }
        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);
                }
            }
        },
    ];
    const _farOptions: ICommandBarItemProps[] = [
        {
            key: 'sort',
            text: t('sort'),
            title: t("sort"),
            iconProps: { iconName: 'sort' },
            disabled: state.managers.isFetching,
            subMenuProps: {
                items: [{
                    key: 'ascending',
                    text: t('ascendingDate'),
                    title: t("ascendingDate"),
                    canCheck: true,
                    checked: !state.managers.isDescending,
                    onClick: () => {
                        dispatch(setSort(false))
                        dispatch(resetManagers())
                        req.setOrder(false)
                        req.setNextto(0)
                        getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))

                    }


                }, {
                    key: 'descending',
                    text: t('descendingDate'),
                    title: t("descendingDate"),
                    canCheck: true,
                    checked: state.managers.isDescending,
                    onClick: () => {
                        dispatch(setSort(true))
                        dispatch(resetManagers())
                        req.setOrder(true)
                        req.setNextto(0)
                        getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))

                    }

                }]
            }
        }


    ];
    const _farBottomOptions: ICommandBarItemProps[] = [
        {
            key: 'results',
            text: t('results') + ': ' + state.managers.numberOfResults,
            title: t('results') + ': ' + state.managers.numberOfResults,
            iconProps: { iconName: 'ShowResults' },
            subMenuProps: {
                items: [{
                    key: '10',
                    text: '10',
                    title: '10',
                    canCheck: true,
                    checked: (state.managers.numberOfResults == 10 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(10))
                        req.setNumofresults(10)
                    }


                }, {
                    key: '50',
                    text: '50',
                    title: '50',
                    canCheck: true,
                    checked: (state.managers.numberOfResults == 50 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(50))
                        req.setNumofresults(50)
                    }

                },
                {
                    key: '100',
                    text: '100',
                    title: '100',
                    canCheck: true,
                    checked: (state.managers.numberOfResults == 100 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(100))
                        req.setNumofresults(100)
                    }

                }]
            }
        }
    ];


    const rolesSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('roles'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.roles.hasMore && !state.roles.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.roles.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedRole([state.roles.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.roles.items.length > 0 && !state.roles.isFetching) {
                roleReq.setNextto(state.roles.items.at(state.roles.items.length - 1).id)
                getRolesPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))
            }
        },
        suggestions: state.roles.items.length > 0 ? state.roles.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.roles.items.length == 0 ? state.roles.isFetching : false,
        isSearching: state.roles.items.length > 0 ? state.roles.isFetching : false,


    };

    const userTypeSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('usersTypes'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.userTypes.hasMore && !state.userTypes.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.userTypes.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedUserType([state.userTypes.items.at(u)]))
            }
        },
        onGetMoreResults: () => {
            if (state.userTypes.items.length > 0 && !state.userTypes.isFetching) {
                userTypeReq.setNextto(state.userTypes.items.at(state.userTypes.items.length - 1).id)
                getUserTypesPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))

            }
        },
        suggestions: state.userTypes.items.length > 0 ? state.userTypes.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.userTypes.items.length == 0 ? state.userTypes.isFetching : false,
        isSearching: state.userTypes.items.length > 0 ? state.userTypes.isFetching : false,

    };
    const onRoleFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetRoles())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        roleReq.setSearch(wrapper)
        roleReq.setNextto(0)
        dispatch(setIsFilteredRolesSet(true))
        getRolesPromise?.abort();
        getRolesPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))

        return [];

    }
    const onUserTypeFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {
        dispatch(resetUserTypes())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        userTypeReq.setSearch(wrapper)
        userTypeReq.setNextto(0)
        dispatch(setIsFilteredUserTypesSet(true))
        getUserTypesPromise?.abort();
        getUserTypesPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))

        return [];
    }


    return (
        <Stack >
            <Popup isOpen={(currentAction == 100)} title={t("addManager")} onDismiss={() => { setCurrenctAction(0) }} isBlocking={true} >

                <UsersForm childrenGap={10} type={FormType.ADD} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(addUser(e))

                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 101)} title={t("editManager")} onDismiss={() => { setCurrenctAction(0) }} isBlocking={true}>
                <UsersForm childrenGap={10} type={FormType.EDIT} fetchData={true} renderObject={state.managers.selected.at(0)} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateUser(e))
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 102)} title={t("editManager")} onDismiss={() => { setCurrenctAction(0) }} isBlocking={true}>
                <UsernameUpdateForm childrenGap={10} type={FormType.EDIT} renderObject={state.managers.selected.at(0)} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateUsername(e))
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 103)} title={t("twoFactor")} onDismiss={() => { setCurrenctAction(0) }} isBlocking={true}>
                <AccountSecurityForm childrenGap={10} type={FormType.EDIT} fetchData={true} renderObject={state.managers.selected.at(0)} onSuccess={(e) => {
                    setCurrenctAction(0)
                    //dispatch(updateUsername(e))
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>


            <Popup isOpen={(currentAction == 1001)} title={t("usersTypes")} onDismiss={() => { setCurrenctAction(0) }} >

                <UserTypesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedUserType([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>


            <Popup isOpen={(currentAction == 1000)} title={t("roles")} onDismiss={() => { setCurrenctAction(0) }} >

                <RolesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedRole([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }
            <CommandBar
                items={state.managers.selected.length == 0 ? mainOptions : _selectionItems}
                farItems={_farOptions}

            //id={actionConfirmationcalloutTargetId}


            />
            {isShareCalloutVisible ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${shareTargetId}`}
                    onDismiss={toggleisShareCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={toggleisShareCalloutVisible} title={t("shareProfile")} value={`https://${window.location.host}/management/users/${state.managers.selected.at(0).internalId}` + ((org == -1) ? "" : "?org=" + org)}></ShareBox>
                </Callout>
            ) : null}

            {state.newPassword ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${resetPasswordActionConfirmationcalloutTargetId}`}
                    onDismiss={() => { dispatch(resetNewPassword()) }}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={() => { dispatch(resetNewPassword()) }} isSecret={true} title={t("newPasswordTitle")} value={state.newPassword}></ShareBox>
                </Callout>
            ) : null}
            {isActionConfirmationCalloutVisible ? (
                <Callout
                    ariaLabelledBy={ActionConfirmationLabelId}
                    target={`#${getActionId(currentAction)}`}
                    onDismiss={toggleisActionConfirmationCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <Stack tokens={{ padding: '20px 24px ' }}>
                        <Text block variant="xLarge" styles={{ root: { marginBottom: 12 } }}>
                            {(currentAction == 1 ? (state.managers.selected.at(0)?.isActive) ? t("deactivateAccount") : t("activateAccount") : currentAction == 2 ? state.managers.selected.at(0)?.isConfirmed ? t("identityUnconfirm") : t("identityConfirm") : currentAction == 4 ? t("resetPassword") : "")}
                        </Text>
                        <Text block variant="small">
                            {(currentAction == 1 ? (state.managers.selected.at(0)?.isActive) ? t("deactivateAccountDesc") : t("activateAccountDesc") : currentAction == 2 ? state.managers.selected.at(0)?.isConfirmed ? t("identityUnconfirmDesc") : t("identityConfirmDesc") : currentAction == 4 ? t("resetPasswordDesc") : "")}

                        </Text>
                        {/* This FocusZone allows the user to go between buttons with the arrow keys.
              It's not related to or required for FocusTrapCallout's built-in focus trapping. */}
                        <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                            <Stack reversed tokens={{ childrenGap: 8, padding: "20px 0px 0px 0px" }} horizontal>
                                <DefaultButton autoFocus onClick={toggleisActionConfirmationCalloutVisible}>{t("cancel")}</DefaultButton>

                                <PrimaryButton onClick={() => {
                                    toggleisActionConfirmationCalloutVisible()
                                    if (state.managers.selected.length > 0) {
                                        if (currentAction == 1) {
                                            let req = new UpdateUserActivityRequest();
                                            req.setProfileid(state.managers.selected.at(0)?.internalId)
                                            req.setIsaccountactive(!state.managers.selected.at(0)?.isActive)

                                            dispatch(updateStatus({ body: req, headers: getHeaders() }))

                                        } else if (currentAction == 2) {

                                        } else if (currentAction == 4) {
                                            let req = new ResetUserPasswordRequest();
                                            req.setProfileid(state.managers.selected.at(0)?.internalId)
                                            dispatch(resetPassword({ body: req, headers: getHeaders() }))
                                        }
                                    }
                                }} text={(currentAction == 1 ? (state.managers.selected.at(0)?.isActive) ? t("deactivateAccount") : t("activateAccount") : currentAction == 2 ? state.managers.selected.at(0)?.isConfirmed ? t("identityUnconfirm") : t("identityConfirm") : currentAction == 4 ? t("reset") : "")}  >

                                </PrimaryButton>
                            </Stack>
                        </FocusZone>
                    </Stack>
                </Callout>
            ) : null}

            {isCalloutVisible ? (
                <Callout
                    ariaLabelledBy={labelId}

                    target={`#${calloutTargetId}`}
                    onDismiss={toggleIsCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    isBeakVisible={true}
                >
                    <Stack tokens={{ padding: 28, childrenGap: 30 }}  >
                        <Text block variant="mediumPlus" >
                            {t("filterDesc")}
                        </Text>
                 

                        <Stack horizontalAlign="space-between" horizontal tokens={{ childrenGap: 20 }} >
                            <Label >{t("usertype")}</Label>
                            <List
                                styles={{ root: { width: 268 } }}
                                inputProps={{ placeholder: t("usertype"), }}
                                suggestionsHeaderText={t('usersTypes')}
                                isLoading={state.userTypes.items.length == 0 ? state.userTypes.isFetching : false}
                                isSearching={state.userTypes.items.length > 0 ? state.userTypes.isFetching : false}
                                moreSuggestionsAvailable={state.userTypes.hasMore && !state.userTypes.isFetching}
                                suggestions={state.userTypes.items.length > 0 ? state.userTypes.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                onGetMoreResults={() => {

                                    if (state.userTypes.items.length > 0 && !state.userTypes.isFetching) {
                                        userTypeReq.setNextto(state.userTypes.items.at(state.userTypes.items.length - 1).id)
                                        getUserTypesPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))

                                    }
                                }}
                                onSuggestionClick={(ev?, item?: any, index?: number) => {

                                    var u = state.userTypes.items.findIndex(e => e.id == item.key)
                                    if (u >= 0) {
                                        dispatch(setSelectedUserType([state.userTypes.items.at(u)]))
                                    }
                                }}
                                isPeoplePicker={false}
                                selectedItems={state.userTypes.selected.length > 0 ? state.userTypes.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                onChange={(e) => {
                                    dispatch(setSelectedUserType([]))

                                }}
                                onEmptyInputFocus={() => {
                                    dispatch(resetUserTypes())
                                    userTypeReq.setSearch(undefined)
                                    userTypeReq.setNextto(0)
                                    dispatch(setIsFilteredUserTypesSet(false))
                                    getUserTypesPromise?.abort()
                                    getUserTypesPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))
                                    return []
                                }}
                                onFilterChanged={onUserTypeFilterChanged}
                                endButtons={[
                                    {
                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                        onClick: () => {
                                            setCurrenctAction(1001)

                                        }
                                    }]}
                            />
                        </Stack>



                        <DialogFooter>
                            <PrimaryButton text={t("search")} onClick={(e => {
                                search(state.searchText);
                                toggleIsCalloutVisible();
                            })} />
                            <DefaultButton text={t("clearFilter")} onClick={() => {
                                clearFilter();
                            }} />

                        </DialogFooter>
                    </Stack>
                </Callout>
            ) : null}

            <Stack.Item align="center"  >
                <Stack horizontal  >
                    <SearchField
                        inputProps={{
                            maxLength: 250,
                            placeholder: t("search"),
                        }}

                        onInputChange={(e) => {
                            dispatch(setSearchText(e));
                            return e;
                        }}
                        endButtons={[
                            { id: calloutTargetId, title: t("filter"), iconProps: { iconName: "filter" }, onClick: toggleIsCalloutVisible },
                            {
                                title: t("search"), checked: true, iconProps: { iconName: "search" }, onClick: () => {
                                    search(state.searchText);
                                    if (isCalloutVisible)
                                        toggleIsCalloutVisible();

                                }
                            }]}
                        onChange={(e) => {
                            const res = state.filters.filter(({ key: key1 }) => !e?.some(({ key: key2 }) => key1 === key2));
                            res?.forEach(e => {
                                if (e.key == 1) {
                                    
                                } else if (e.key == 2) {
                                    dispatch(setSelectedUserType([]))
                                    req.setUsertype(-1)
                                } else if (e.key == 3) {
                                } else if (e.key == 4) {
                                } else if (e.key == 5) {

                                }
                            });

                        }}

                        onResolveSuggestions={() => { return [] }}
                        selectedItems={state.filters.map(e => { return { name: e.name, key: e.key } as ITag }) || []}
                        onSearch={(e) => {
                            search(state.searchText);
                            if (isCalloutVisible)
                                toggleIsCalloutVisible();
                        }}
                        onClear={(e) => {
                            dispatch(setSearchText(undefined))
                            if (state.managers.isFilteredSet) {
                                search(undefined);
                            }
                            /*if (req.getSearch() && !state.managers.isFilteredSet) {
                                dispatch(resetRoles())
                                req.setNextto(undefined)
     
                                req.setSearch(undefined)
     
                                getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))
                            }*/
                        }}
                        showIcon
                    />
                </Stack>
            </Stack.Item>



            <Table
                setKey="managers"
                items={state.managers.items}
                columns={c}
                checkboxVisibility={props.isSelection ? CheckboxVisibility.always : CheckboxVisibility.onHover}
                width={props.isSelection ? '80vw' : undefined}
                height={props.isSelection ? "60vh" : state.message == undefined ? "calc(100vh - 176px)" : "calc(100vh - 224px)"}
                selection={_selection}
                compRef={ref}
                onScroll={(e) => {
                    const bottom = e?.currentTarget?.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
                    if (bottom && !state.managers.isFetching && state.managers.hasMore) {
                        req.setNextto(state.managers.items.at(state.managers.items.length - 11)?.internalId)
                        getManagersPromise?.abort();
                        getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))

                    }
                }}
                selectionMode={SelectionMode.single}
                disableSelectionZone={state.isChangeStateLoading}
                enableShimmer={state.managers.items.length == 0 && state.managers.isFetching}
                isColumnSortingEnabled={state.managers.selected.length == 0}
                layoutMode={props.isSelection ? DetailsListLayoutMode.fixedColumns : DetailsListLayoutMode.justified}
                onRowDidMount={(item?: any, index?: number) => {
                    //alert(index)
                    if (index == state.managers.items.length - 11) { // last element renderd
                        const { current } = ref;
                        if (current) {
                            if (state.managers.items.length > 0 && !state.managers.isFetching && state.managers.hasMore) {
                                if (current.scrollHeight == current.clientHeight) { // scroll not shown? get more data 
                                    req.setNextto(state.managers.items.at(state.managers.items.length - 11)?.internalId)
                                    getManagersPromise?.abort();
                                    getManagersPromise = dispatch(getManagerUsers({ body: req, headers: getHeaders() }))
                                }


                            }
                        }
                    }
                }}
                numberOfResultsOptions={[10, 50, 100]}
                selectedNumberOfResults={state.managers.numberOfResults}
                onNumberOfResultsChange={(e) => {
                    dispatch(setNumberOfResults(e))
                    req.setNumofresults(e)
                }}


            />


            {props.isSelection ? <DialogFooter>
                <PrimaryButton disabled={state.managers.isFetching || state.managers.selected.length == 0} text={state.managers.isFetching ? undefined : t("select")} onClick={() => {
                    if (props.onItemSelected && state.managers.selected.length > 0) {
                        props.onItemSelected(state.managers.selected.at(0))
                    }
                }} >

                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.managers.isFetching ? "block" : "none") } }} />

                </PrimaryButton>
                <DefaultButton disabled={state.managers.isFetching} text={t("discard")} onClick={() => {
                    if (props.onCancel) {
                        props.onCancel()
                    }
                }} />
            </DialogFooter> : undefined}

        </Stack>



    );
}




